import { TOGGLE_MENU } from '../actions/menuActions';

const initialState = {
  menuMobileActive: false,
};

const menuReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_MENU:
      return {
        ...state,
        menuMobileActive: !state.menuMobileActive,
      };
    default:
      return state;
  }
};

export default menuReducer;